import React from "react";
import { useSmoothScroll } from "../../hooks/useSmoothScroll";

interface NavbarCTAProps {
  label?: string;
  href?: string;
  className?: string;
}

export function NavbarCTA({ 
  label = "Fale Comigo", 
  href = "#contato", 
  className = "nav__cta" 
}: NavbarCTAProps) {
  const smoothScroll = useSmoothScroll();

  return (
    <a
      className={`${className} nav__cta--orange`}
      href={href}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => smoothScroll(e, href)}
    >
      {label}
    </a>
  );
}